import React, { useState, useEffect } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';

const ResolutionModal = ({ show, onHide, selectedData, onConfirm }) => {
    const [enableRelist, setEnableRelist] = useState(false);

    const { dispute, resolution } = selectedData || {};

    useEffect(() => {
        if (show) {
            setEnableRelist(false);
        }
    }, [show]);

    if (!dispute || !resolution) return null;

    const handleConfirm = () => {
        const resolutionAction = enableRelist ? 'ENABLE_RELIST' : null;
        onConfirm(resolution, resolutionAction);
        onHide();
    };

    const isSidingWithSeller = resolution === 'RESOLVED_FAVOR_SELLER';
    const isDismissing = resolution === 'DISMISSED';

    const getModalBody = () => {
        if (isDismissing) {
            return <p>You are about to dismiss this dispute. No further action will be taken on the item, and the case will be closed.</p>;
        }
        return (
            <>
                <p>You have chosen to side with the <strong>{isSidingWithSeller ? 'Seller' : 'Buyer'}</strong> for item: <strong>{dispute.itemId?.item_name}</strong>.</p>
                <hr />
                {isSidingWithSeller && (
                    <Form.Group controlId="relistCheckbox">
                        <Form.Check 
                            type="checkbox"
                            label="Enable this item to be relisted by the seller."
                            checked={enableRelist}
                            onChange={(e) => setEnableRelist(e.target.checked)}
                        />
                        <Form.Text className="text-muted">
                            If checked, the item status will be updated to allow relisting.
                        </Form.Text>
                    </Form.Group>
                )}
            </>
        );
    };
    
    return (
        <Modal show={show} onHide={onHide} centered>
            <Modal.Header closeButton>
                <Modal.Title>Confirm Resolution</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {getModalBody()}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>Cancel</Button>
                <Button variant="primary" onClick={handleConfirm}>
                    Confirm and Resolve
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ResolutionModal;